<div class="features-section">
  <div class="overview-heading-wrapper">
    <p class="overview-label">Everything You Need to Buy Right</p>
    <h2 class="overview-heading">Built for Complete Purchase Control</h2>
  </div>

  <div class="overview-shell">
    <div class="app-row" *ngFor="let feature of features; let i = index" [class.app-row--reverse]="i % 2 === 1">
      <div class="app-row-visual">
        <span class="app-row-index">{{ i + 1 }}</span>
        <div class="app-row-frame">
          <img [src]="feature.image" [alt]="feature.title" />
        </div>
      </div>
      <div class="app-row-body">
        <h3 class="app-row-title">{{ feature.title }}</h3>
        <ul class="app-row-points">
          <li *ngFor="let point of feature.points">{{ point }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
